import { render, staticRenderFns } from "./ModalFormsDownloadNew.vue?vue&type=template&id=7c66b49b&"
import script from "./ModalFormsDownloadNew.vue?vue&type=script&lang=js&"
export * from "./ModalFormsDownloadNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports